import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import NpsAdmin from './NpsAdmin';
import NpsFranchisee from './NpsFranchisee';

/**
 * Entry point for /nps. Branches on role:
 *  • admin       → network view (map + rollups); can drill into a location via ?af
 *  • franchisee  → their own location's view (results + share links)
 *  • fbc         → a location's view when ?af is set (they open one from the network)
 */
export default function NpsPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const af = params.get('af');

  function drillIn(afNumber: string) {
    setParams({ af: afNumber });
  }
  function clearDrill() {
    setParams({});
  }

  const isAdmin = user?.role === 'admin';
  const franchiseeAf = af ?? user?.afNumbers?.[0] ?? null;

  return (
    <div className="nps-shell">
      <div className="nps-topbar">
        <Link to="/" className="nps-back">← Back to dashboard</Link>
        {isAdmin && af && (
          <button type="button" className="nps-back-btn" onClick={clearDrill}>
            ← Back to network
          </button>
        )}
      </div>

      {isAdmin && !af && <NpsAdmin onDrillIn={drillIn} />}

      {isAdmin && af && <NpsFranchisee af={af} />}

      {!isAdmin && (
        franchiseeAf ? (
          <NpsFranchisee af={franchiseeAf} />
        ) : (
          <div className="nps-page">
            <div className="ds-section-header"><h2>Net Promoter Score</h2></div>
            <p className="nps-respond-muted">
              Open a specific location from the dashboard to see its NPS.
            </p>
          </div>
        )
      )}
    </div>
  );
}
